export default "__VITE_ASSET__DKNC6DgK__"